import { useEffect, useRef, useState } from 'react';
import {
  SubMenuItem,
  MenuItem,
  SidebarContainer,
  SubMenuContainer,
  MenuGroup,
} from '../pages/GlobalStyles';
import { HiChevronDown, HiChevronRight } from 'react-icons/hi2';
import ReactTooltip from 'react-tooltip';

import { useHistory, useLocation } from 'react-router-dom';
import saratogaLogo from '../assets/images/saratogaLogo.svg';
import { useTranslation } from 'react-i18next';
import { RoutePath } from '../helpers/RoutePath';

export default function Sidebar({ items }: any) {
  const { t } = useTranslation();
  const location = useLocation();
  const [open, setOpen] = useState<string | null>(null);
  const [collapsed, setCollapsed] = useState(true);
  const [activePath, setActivePath] = useState<string>(location.pathname);
  const [animating, setAnimating] = useState(false);
  const durationRef = useRef<number>(400); // ms, matches CSS

  // Flip animating when collapsed changes
  useEffect(() => {
    setAnimating(true);
    const id = setTimeout(() => setAnimating(false), durationRef.current + 100); // buffer
    return () => clearTimeout(id);
  }, [collapsed]);

  const navigate = useHistory();

  const toggle = (label: string) => {
    if (!collapsed) {
      setOpen(open === label ? null : label);
    }
  };

  const isParentActive = (item: any) => {
    if (item.path && activePath === item.path) return true;

    if (item.children) {
      return item.children.some((child: any) => child.path === activePath);
    }

    return false;
  };

  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SidebarContainer
        onMouseEnter={() => setCollapsed(false)}
        onMouseLeave={() => setCollapsed(true)}
        collapsed={collapsed}
      >
        <div className='w-100'>
          <MenuItem
            companyLogo={true}
            className='mb-3'
            onClick={() => navigate.replace(RoutePath.DASHBOARD)}
          >
            <div className='sidebar-logo-container'>
              <img
                src={saratogaLogo}
                alt='Sidebar Logo'
                className='h-1-point-5-rem w-1-point-5-rem'
              />
            </div>
            {!collapsed && (
              <span className='label fw-500 font-size-point-875-rem'>
                {t('saratoga')}
              </span>
            )}
          </MenuItem>

          {items.map((item: any) => (
            <MenuGroup
              key={item.label}
              isOpen={!collapsed && open === item.label && item.children}
            >
              <MenuItem
                // onMouseEnter={() => setHoveredLabel(item.label)}
                // onMouseLeave={() => setHoveredLabel(null)}
                data-tip={collapsed ? item.label : ''}
                data-for={collapsed ? `menu-${item.label}` : ''}
                collapsed={collapsed}
                onClick={() => {
                  toggle(item.label);
                  navigate.replace(item.path);
                }}
                style={{
                  backgroundColor: isParentActive(item)
                    ? 'var(--sidebar-active-color)'
                    : '',
                  color: isParentActive(item) ? 'var(--sidebar-bg-color)' : '',
                  transition: 'all 0.5s ease-in-out',
                  width: '100%',
                }}
                animating={animating}
              >
                {item.icon && <div className='icon-wrapper'>{item.icon}</div>}

                <span className='label'>{item.label}</span>
                {!collapsed &&
                  item.children &&
                  (open === item.label ? (
                    <HiChevronDown />
                  ) : (
                    <HiChevronRight />
                  ))}
              </MenuItem>

              {collapsed && (
                <ReactTooltip
                  id={`menu-${item.label}`}
                  place='right'
                  effect='solid'
                >
                  {item.label}
                </ReactTooltip>
              )}

              {!collapsed && item.children && open === item.label && (
                <SubMenuContainer
                  collapsed={collapsed}
                  isOpen={open === item.label}
                >
                  {item.children.map((sub: any) => (
                    <SubMenuItem
                      key={sub.label}
                      animating={animating}
                      onClick={() => navigate.replace(sub.path)}
                    >
                      <span className='label'>{sub.label}</span>
                    </SubMenuItem>
                  ))}
                </SubMenuContainer>
              )}
            </MenuGroup>
          ))}
        </div>

        {/* <div className='p-2 w-100'>
          <MenuItem
            onMouseEnter={() => setHoveredLabel('toggle-sidebar')}
            onMouseLeave={() => setHoveredLabel(null)}
            data-tip={collapsed ? 'toggle-sidebar' : ''}
            data-for={collapsed ? `menu-toggle-sidebar` : ''}
            collapsed={collapsed}
            onClick={() => {
              setCollapsed(!collapsed);
              if (!collapsed) {
                setHoveredLabel(null);
              }
            }}
            style={{ transition: 'all 0.2s ease-in-out', width: '100%' }}
            animating={animating}
          >
            <div className='icon-wrapper'>
              {collapsed ? (
                <ChevronsRight width={18} height={18} />
              ) : (
                <ChevronsRightLeft width={18} height={18} />
              )}
            </div>

            <ToggleSidebarSpan className='label'>
              {t('toggle_sidebar')}
            </ToggleSidebarSpan>
          </MenuItem>

          {collapsed && (
            <ReactTooltip
              id={`menu-toggle-sidebar`}
              place='right'
              effect='solid'
            >
              {t('toggle_sidebar')}
            </ReactTooltip>
          )}
        </div> */}
      </SidebarContainer>
    </>
  );
}
